import api from "../service/dadosSolicitante.service";
import * as types from "./dadosSolicitante.actionTypes";
import dadosSolicitanteActions from "./dadosSolicitante.actions";
import dadosSolicitanteSelectors from "./dadosSolicitante.selectors";
import { takeEvery, call, put, select } from "redux-saga/effects";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.SOLICITANTE_GET, getSolicitante);
}

function* getSolicitante(action) {
  const { payload } = action;
  let dadosSolicitante = yield select(
    dadosSolicitanteSelectors.dadosSolicitante
  );
  if (dadosSolicitante.CpfCnpjSolicitante != payload) {
    try {
      const result = yield call(api.getSolicitante, payload);

      const { data } = result;

      let solicitante = {
        CpfCnpjSolicitante: payload,
        NomeSolicitante: data.NomeSolicitante,
        EmailSolicitante: data.EmailSolicitante,
        RgIeSolicitante: data.RgIeSolicitante,
        TelefoneSolicitante: data.TelefoneSolicitante,
        CelularSolicitante: data.CelularSolicitante,
        EnderecoSolicitante: data.EnderecoSolicitante,
      };

      yield put(dadosSolicitanteActions.setSolicitante(solicitante));
    } catch (e) {
      let solicitante = {
        CpfCnpjSolicitante: undefined,
        NomeSolicitante: undefined,
        EmailSolicitante: undefined,
        RgIeSolicitante: undefined,
        TelefoneSolicitante: undefined,
        CelularSolicitante: undefined,
        EnderecoSolicitante: {},
      };
      yield put(dadosSolicitanteActions.setSolicitante(solicitante));
    }
  }
}
